import { signOut } from "aws-amplify/auth";
import { FCMManager } from "@/fcm";
import { useWebSocket } from "@/websocket/client";

export const useSignOut = () => {
  const { setAuthToken } = useWebSocket();
  return () => {
    signOut();
    setAuthToken(null);
    FCMManager.revoke();
  };
};
